import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { InsurerFilterProps, StatusFilterLabelText } from './filter-types';

export const InsurerFilter = ({
  control,
  name = 'insurers',
  insurers,
  hasError = false,
  variant = 'standard',
  sx = { minWidth: 230, maxWidth: 230 },
  label = StatusFilterLabelText.INSURER,
  loading = false,
}: InsurerFilterProps): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }): JSX.Element => (
      <Autocomplete
        multiple
        id="insurers-select"
        options={!hasError ? insurers : []}
        disabled={!!hasError || loading}
        getOptionLabel={(option): string => option.name}
        size="small"
        sx={sx}
        limitTags={1}
        blurOnSelect={true}
        onChange={(_, newValue): void => onChange(newValue)}
        value={value}
        renderInput={(params): JSX.Element => (
          <HHTextField
            {...params}
            hhVariant="variant-bypass"
            variant={variant}
            label={label}
            error={!!hasError}
            helperText={hasError ? 'insurers unavailable' : ''}
          />
        )}
      />
    )}
  />
);
